import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AccountService } from '../../../../services/account.service';
import { AddAddonDialogComponent } from './add-addon-dialog/add-addon-dialog.component';
import { EditLicenseDialogComponent } from './edit-license-dialog/edit-license-dialog.component';
import { RenewLicenseDialogComponent } from './renew-license-dialog/renew-license-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { RemoveAddonDialogComponent } from './remove-addon-dialog/remove-addon-dialog.component';
import { ChangeSubscriptionDialogComponent } from './change-subscription-dialog/change-subscription-dialog.component';
import { RenewDetailsComponent } from '../license-details/renew-details/renew-details.component';
import { CommonfilterService } from 'src/app/services/commonfilter.service';
import { RevertAddonDialogComponent } from './revert-addon/revert-addon-dialog.component';
import { projectConstants } from '../../../../shared/constants/project-constants';
import { StatementBysystemComponent } from './statement-bysystem/statement-bysystem.component';

@Component({
  selector: 'app-license-details',
  templateUrl: './license-details.component.html',
  styleUrls: ['./license-details.component.css']
})
export class LicenseDetailsComponent implements OnInit {
  license_type = projectConstants.LICENSE_TYPE;
  licenseDetails: any = {};
  acclicenseDetails: any = {};
  addonlist: any = [];
  acclicenseAudits: any = [];
  accaddonAudits: any = [];
  accountId: number;
  showrenewbtn = true;
  showsubplan = false;
  license_downgrade: any;
  licensePackages: any = [];
  downgradeLicense: any;
  accAddonDetails: any = [];
  addon_downgrade: any;
  addonDownGraded: any = [];
  licenseDownGrade: string;
  addons: any = [];
  subscriptionDetails: any;
  nextBillCycle: any;
  cop: any;
  configData: any = {};
  licSubscriptionTypeDetails: any;
  accountType: any;
  centralised: any;
  showcentralised: any;
  constructor(private route: ActivatedRoute,
    private accountService: AccountService,
    private dialog: MatDialog,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private commonfilter: CommonfilterService) { }
  ngOnInit() {
    this.accountService.getLicensePackages()
      .subscribe(res => {
        this.licensePackages = res;
      });
    // get addonmetadata
  
    // console.log( 'active params.......' + this.route.snapshot.paramMap.get('id'));
    this.route.parent.parent.params.subscribe(params => {
      this.accountId = params['id'];
      this.getLicenseAddOnDetails(this.accountId);
      this.getSubscriptionDetails();
    });
    this.accountService.getupgradableAddonss(this.accountId)
    .subscribe(res => {
      this.addons = res;
    });
    this.getLicenseAudits();
    this.getAddonAudits();
    this.getnextBillCycle();
    // this.corporateset();
  }
  getSubscriptionDetails() {
    this.accountService.getSubscriptionDetails(this.accountId)
      .subscribe(response => {
        this.subscriptionDetails = response;
        // console.log(this.subscriptionDetails);
      });
  }
  getLicenseAddOnDetails(accountId) {
    this.accountService.licenseDetails(this.accountId)
      .subscribe(res => {
        this.licenseDetails = res;
        // console.log(res);
        this.license_downgrade = '';
        this.acclicenseDetails = this.licenseDetails.accountLicense;
        this.accountType = this.licenseDetails.accountTypeEnum;
        this.accAddonDetails = this.licenseDetails.addons;
        if (this.accAddonDetails) {
          this.addonDownGraded = [];
          this.accAddonDetails.forEach(addons => {
            if (addons.downgradTo) {
              this.addon_downgrade = addons.downgradTo;
              this.addonDownGraded.push({ 'downgradedAddon': this.getDowngradedAddon(this.addon_downgrade) });
            }
          });
        }
        // console.log('license details downgrade to....' + this.acclicenseDetails.downgradTo);
        if (this.acclicenseDetails.downgradTo !== undefined) {
          this.license_downgrade = this.acclicenseDetails.downgradTo;
          // console.log(this.license_downgrade);
          // console.log(this.license_downgrade);
          this.licenseDownGrade = this.getDowngradedLicense(this.license_downgrade);
          // console.log(this.licenseDownGrade);
        }
        // console.log(this.license_downgrade);
        // if (this.license_downgrade !== '') {
        //   for (let i = 0; i < this.licensePackages.length; i++) {
        //     if (this.licensePackages[i].pkgId === this.license_downgrade) {
        //       this.downgradeLicense = this.licensePackages[i].pkgName;
        //     }
        //   }
        // }
        if (this.acclicenseDetails.type === 'Production') {
          this.showrenewbtn = false;
        }
        this.addonlist = this.licenseDetails.addons;
        // console.log(this.addonlist);
      });
  }
  corporateset() {
   
    this.accountService.corporatesettings(this.accountId)
    
      .subscribe(res => {
        this.centralised = res;
        this.showcentralised = this.centralised.isCentralised;
        // console.log(this.showcentralised);
        // console.log(this.centralised);
       
      });
  }
  getnextBillCycle() {
    this.accountService.getnextBillCycle(this.accountId)
      .subscribe(res => {
        this.nextBillCycle = res;
      });
  }
  getLicenseAudits() {
    this.accountService.getLicenseAudits(this.accountId).
      subscribe(res => {
        this.acclicenseAudits = res;
      });
  }
  getDowngradedLicense(license) {
    let licenseName = '';
    if (license !== '') {
      for (let i = 0; i < this.licensePackages.length; i++) {
        if (this.licensePackages[i].pkgId === license) {
          licenseName = this.licensePackages[i].pkgName;
          break;
        }
      }
    }
    return licenseName;
  }
  getDowngradedAddon(addon) {
    let addonName = '';
    for (let i = 0; i < this.addons.length; i++) {
      for (let j = 0; j < this.addons[i].addons.length; j++) {
        if (this.addons[i].addons[j].addonId === addon) {
          addonName = this.addons[i].addons[j].addonName;
          break;
        }
      }
    }
    // console.log(addonName);
    return addonName;
  }
  getAddonAudits(): any {
    this.accountService.getAddonAudits(this.accountId)
      .subscribe(res => {
        this.accaddonAudits = res;
      });
  }
  revert(addonorlicense, type) {
    const dialogRef = this.dialog.open(RevertAddonDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'addonorlicense': addonorlicense, 'type': type }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
    });
  }
  addAddons() {
    const dialogRef = this.dialog.open(AddAddonDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'addon': this.addonlist, 'type': 'account' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
    });
  }
  renewLicense() {
    const dialogRef = this.dialog.open(RenewLicenseDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 
      'type': 'account' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();

    });
  }
  addAddress() {
    const dialogRef = this.dialog.open(RenewLicenseDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 
      'type': 'addAddress' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();

    });
  }
  
  showRenewedDetails(license) {
    const dialogRef = this.dialog.open(RenewDetailsComponent, {
      width: '800px',
      data: { 'accountId': this.accountId, 'licensedetails': license }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
    });
  }
  changeLicense() {
    const dialogRef = this.dialog.open(EditLicenseDialogComponent, {
      width: '600px',
      // tslint:disable-next-line:max-line-length
      data: { 'accountId': this.accountId, 'licensedetails': this.acclicenseDetails, 'downgradeLicense': this.license_downgrade, 'type': 'account' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
    });
  }
  removeAddon(addon) {
    console.log(addon)
    const dialogRef = this.dialog.open(RemoveAddonDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'addonId': addon.accountLicId, 'type': 'account' }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();

    });
  }
  changeSubscription() {
    const dialogRef = this.dialog.open(ChangeSubscriptionDialogComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'details': this.subscriptionDetails }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
      this.getSubscriptionDetails();

    });
  }
  changeState() {
    const dialogRef = this.dialog.open(StatementBysystemComponent, {
      width: '600px',
      data: { 'accountId': this.accountId, 'details': this.subscriptionDetails }
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getLicenseAddOnDetails(this.accountId);
      this.getLicenseAudits();
      this.getAddonAudits();
      this.getSubscriptionDetails();

    });
  }
  
  licenseusage() {
    this.router.navigate(['../licenseusage'],  {queryParams: {accountId: this.accountId}, relativeTo: this.activatedRoute});
   }
  loginAccount(accountId) {
  }
  confirm_autogeneration(e) {
   
      if(this.licenseDetails.stmtCreatedBySystem){
        e.source.checked = true;
        const dialogRef = this.dialog.open(StatementBysystemComponent, {
          width: '600px',
          data: { 'accountId': this.accountId, 'stmtCreatedBySystem': this.licenseDetails.stmtCreatedBySystem }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.getLicenseAddOnDetails(this.accountId);
          this.getLicenseAudits();
          this.getAddonAudits();
          this.getSubscriptionDetails();
    
        }); 
      }
      else if(!this.licenseDetails.stmtCreatedBySystem){
        e.source.checked = false;
        const dialogRef = this.dialog.open(StatementBysystemComponent, {
          width: '600px',
          data: { 'accountId': this.accountId, 'stmtCreatedBySystem': this.licenseDetails.stmtCreatedBySystem }
        });
        dialogRef.afterClosed().subscribe(result => {
          this.getLicenseAddOnDetails(this.accountId);
          this.getLicenseAudits();
          this.getAddonAudits();
          this.getSubscriptionDetails();
    
        }); 
      }
    
  }
}
